import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const nomenclatureGuideVersionHistorySlice = createSlice({
  name: 'nomenclatureGuideVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default nomenclatureGuideVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = nomenclatureGuideVersionHistorySlice.actions;
